import Vue from 'vue'
import Vuex from 'vuex'
import { signOut } from '@/common/services/modules/auth'
import createPersistedState from 'vuex-persistedstate'
import moduleNotifications from './modules/Notifications'
import moduleOnboarding from './modules/Onboarding'
import moduleWidgets from './modules/Widgets'
import moduleUserDetails from './modules/UserDetails'
import moduleGeneralIndicators from './modules/GeneralIndicators'
import moduleOrdersSearch from './modules/OrdersSearch'
import Cookies from 'js-cookie'
import { changeContract } from '@/common/services'

Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
    oidcUser(state) {
      return state.userInfos
    },
    isNotificationSender: state => {
      const listAllProducts = state.listEntities.flatMap(
        ({ products }) => products
      )

      const listAllRoles = listAllProducts.flatMap(({ roles }) => roles)

      const role = 'MyClearSale:NotificationSender'
      const filterRoleNotificationSender = listAllRoles.filter(
        ({ roleName }) => roleName === role
      )

      return !!filterRoleNotificationSender.length
    },
    isBilling: state => {
      const currentEntityRoles = state.currentEntity.products.flatMap(
        ({ roles }) => roles
      )

      const role = 'Financeiro:Financeiro'
      const filterRoleFinanceiro = currentEntityRoles.filter(
        ({ roleName }) => roleName === role
      )

      return !!filterRoleFinanceiro.length
    },
    isDevEnv() {
      return (
        window.location.href.includes('mydev') ||
        window.location.href.includes('localhost')
      )
    },
    isMenuListOpen(state) {
      return state.visibleMenuList
    },
    isProductsOpen(state) {
      return state.visibleProducts
    },
    entitiesMenuOpen(state) {
      return state.visibleEntitiesMenu
    }
  },
  state: {
    visibleLoading: false,
    visibleOverlay: false,
    visibleSnackbar: false,
    visibleMenu: false,
    visibleNotifications: false,
    visibleProducts: false,
    visibleMenuList: false,
    visibleEntitiesMenu: false,
    userData: {},
    listEntities: [],
    currentEntity: null,
    userDetails: undefined,
    visibleCustomLoading: false,
    userItems: {
      productsData: [],
      applicationsData: []
    },
    userInfos: {}
  },
  mutations: {
    UPDATE_USER_INFOS(state, userInfos) {
      Object.assign(state.userInfos, userInfos)
    },
    HANDLE_LOADING(state, visible) {
      state.visibleLoading = visible
    },
    HANDLE_PROGRESS_LOADING(state, visible) {
      state.visibleCustomLoading = visible
    },
    HANDLE_OVERLAY(state, visible) {
      state.visibleOverlay = visible
    },
    VISIBLE_MENU(state, visible) {
      state.visibleMenu = visible
    },
    VISIBLE_PRODUCTS(state, visible) {
      state.visibleProducts = visible
    },
    VISIBLE_MENU_LIST(state, visible) {
      state.visibleMenuList = visible
    },
    VISIBLE_ENTITIES_LIST(state, visible) {
      state.visibleEntitiesMenu = visible
    },
    VISIBLE_NOTIFICATIONS(state, visible) {
      state.visibleNotifications = visible
    },
    HANDLE_SNACKBAR(state, visible) {
      setTimeout(() => {
        state.visibleSnackbar = visible
        setTimeout(() => {
          state.visibleSnackbar = false
        }, 5000)
      }, 1000)
    },
    ADD_USER_DATA: (state, data) => {
      state.userData = Object.assign({}, data)
    },
    SET_USER_CURRENT_ENTITY: (state, data) => {
      state.currentEntity = Object.assign({}, data)
      changeContract(data.entityLegacyId)
    },
    SET_USER_DETAILS: (state, data) => {
      state.userDetails = Object.assign({}, data)
    },
    SET_USER_ITEMS: (state, data) => {
      state.userItems = Object.assign({}, data)
    },
    SET_LIST_ENTITIES(state, entities) {
      const cookie = Cookies.get('active-contract')
      if (!cookie) {
        const userEntitity = state.userInfos?.entity
        const currentEntity = entities.find(
          ({ entitiesId }) => entitiesId === userEntitity
        )
        state.currentEntity = currentEntity
        changeContract(currentEntity.entityLegacyId)
      }
      state.listEntities = [...entities]
    }
  },
  actions: {
    async signOutOidc({ commit }) {
      commit('HANDLE_PROGRESS_LOADING', true)
      try {
        const {
          /*eslint-disable*/
          data: { logout_url }
        } = await signOut()
        localStorage.removeItem('code')
        window.location = logout_url
      } catch (e) {
      } finally {
        commit('HANDLE_PROGRESS_LOADING', false)
      }
    },
    setMenuListVisibility({commit}, visibleMenuList) {
      commit('VISIBLE_MENU_LIST', visibleMenuList)
    },
    setProductsVisibility({commit}, visibleProducts) {
      commit('VISIBLE_PRODUCTS', visibleProducts)
    },
    setNotificationsVisibility({commit}, visibleNotifications) {
      commit('VISIBLE_NOTIFICATIONS', visibleNotifications)
    },
    setMenuVisibility({commit}, visibleMenu) {
      commit('VISIBLE_MENU', visibleMenu)
    },
    setEntitiesMenuVisibility({commit}, visibleEntitiesMenu) {
      commit('VISIBLE_ENTITIES_LIST', visibleEntitiesMenu)
    }
  },
  modules: {
    notifications: moduleNotifications,
    onboarding: moduleOnboarding,
    widgets: moduleWidgets,
    entitiesDetails: moduleUserDetails,
    generalIndicators: moduleGeneralIndicators,
    orders: moduleOrdersSearch
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
    })
  ]
})
